export default __webpack_public_path__ + "static/media/AMNH_05.e5254eab.png";